export default "__VITE_ASSET__Dt7y3gEJ__";